module.exports = __webpack_public_path__ + "img/none_comm@2x.f2fcab36.png";